import { useEffect, useRef } from "react";

import { useCardsNotShown } from "../../../context/CardsNotShownContext";

type FailureReasonByActionId = ReadonlyMap<string, string>;

function failureSignatureOf(reasonByActionId: FailureReasonByActionId): string {
  return JSON.stringify(Array.from(reasonByActionId).sort(([leftActionId], [rightActionId]) => (leftActionId < rightActionId ? -1 : leftActionId > rightActionId ? 1 : 0)));
}

export function useFailedCardsNotShown(reasonByActionId: FailureReasonByActionId, source: string): void {
  const { markNotShown } = useCardsNotShown(source);
  const actionIdsMarkedRef = useRef<Set<string>>(new Set());
  const failureSignature = failureSignatureOf(reasonByActionId);

  useEffect(() => {
    const actionIdsMarked = actionIdsMarkedRef.current;
    const failures: Array<[string, string]> = JSON.parse(failureSignature);
    const actionIdsFailing = new Set(failures.map(([actionId]) => actionId));
    for (const [actionId, reason] of failures) {
      markNotShown([actionId], reason);
      actionIdsMarked.add(actionId);
    }
    for (const actionId of Array.from(actionIdsMarked)) {
      if (actionIdsFailing.has(actionId)) continue;
      markNotShown([actionId], null);
      actionIdsMarked.delete(actionId);
    }
  }, [failureSignature, markNotShown]);

  useEffect(() => {
    const actionIdsMarked = actionIdsMarkedRef.current;
    return () => {
      for (const actionId of actionIdsMarked) markNotShown([actionId], null);
      actionIdsMarked.clear();
    };
  }, [markNotShown]);
}
